<template>
  <div class="warnlist" v-if="this.warnList.length> 0">
    <div class="title">
      <el-image :src="iconUrl" class="title-icon"></el-image>
      <span>预警提醒</span>
    </div>
    <div v-for="(item, index) in warnList" :key="index" class="content">
      <span>{{ item.desc }}</span>
    </div>
    <el-image :src="warnPng" class="img"/>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import {
  Cartesian3,
  NearFarScalar
} from 'cesium';
import { mapGetters } from 'vuex';
import { getShipWarnList } from '@/api/modules/proxy'
import warnIcon from '@/assets/png/warnIcon.png'
import warn from '@/assets/png/warn.png'
export default defineComponent({
  name: 'WarnList',
  props: {
    viewer: {
      type: Object,
      default: () => {
        return null
      }
    },
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    }
  },
  data() {
    return {
      iconUrl: warnIcon,
      warnPng: warn,
      warnList: [],
      icons: [],
      currentShip: null
    }
  },
  computed: {
    ...mapGetters(['mmsi', 'aisShipList']),
    clientWidthScale() {
      return this.clientWidth / 1000;
    }
  },
  watch: {
    mmsi: function(newVal, oldVal) {
      if (!newVal) {
        return false;
      }
      const shipObj = this.aisShipList.filter((item) => {
        return item.mmsi === newVal;
      })[0] || {};
      this.currentShip = shipObj
      this.findWarnList(newVal, shipObj.imo)
    }
  },
  methods: {
    findWarnList(mmsi, imo) {
      getShipWarnList(mmsi, imo).then(res => {
        const data = res && res.data ? res.data : []
        this.clearWarnList()
        this.warnList = []
        for(let i=0;i<data.length;i++) {
          const item = data[i]
          item.desc = item.desc.replace('船舶', this.currentShip.name)
          this.warnList.push({
            desc: item.desc,
            formId: item.formId
          })
          this.positionWarn(item)
        }
      })
    },
    positionWarn(item) {
      const point = item.point
      const scale = this.clientWidthScale;

      const billboard = this.viewer.addEntity({
        name: 'ship',
        position: Cartesian3.fromDegrees(
          Number(point.lon),
          Number(point.lat),
          0
        ),
        billboard: {
          image: './png/warnIcon.png',
          scaleByDistance: new NearFarScalar(1, scale / 0.8, 2e7, scale / 3),
        },
      }, item.formId);
      this.icons.push(billboard)
    },
    clearWarnList() {
      if(this.icons.length> 0) {
        for(let i=0;i<this.icons.length;i++) {
          this.viewer.removeEntity(this.icons[i])
        }
        this.icons = []
      }
    }
  }
})
</script>

<style lang="scss" scoped>

@media screen and (max-width: 1920px) {
  .warnlist {
    height: 100%;
    width: 30vw;
    color: white;
    font-size: 12px;
    text-align: left;
    line-height: 10px;
    padding: 5px;
    background-color: rgba(0,0,0, 0.5);
    .content {
      margin-left: 15px;
      line-height: 20px;
    }
    .img {
      position:absolute; 
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    .title {
      color:chocolate;
      font-weight: 600;
      margin-left: 10px;
      display: flex;
      padding: 5px 0 0 0;
    }
    .title-icon {
      height: 15px;
      width: 12px;
      margin-right: 8px;
      top: -3px;
    }
  }
}

@media screen and (min-width: 1921px) and (max-width: 2560px) {
  .warnlist {
    height: 100%;
    width: 20vw;
    color: white;
    font-size: 18px;
    text-align: left;
    line-height: 10px;
    padding: 10px;
    background-color: rgba(0,0,0, 0.5);
    .content {
      margin-left: 15px;
      line-height: 20px;
    }
    .img {
      position:absolute; 
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    .title {
      color:chocolate;
      font-weight: 600;
      margin-left: 10px;
      display: flex;
      padding: 5px 0 0 0;
      font-size: 16px;
    }
    .title-icon {
      height: 18px;
      width: 14px;
      margin-right: 8px;
      top: -3px;
    }
  }
}
  
</style>